// Page-specific JS voor /bavik/dranouter-actie:
// 18+ leeftijdscheck op het Geboortedatum-veld (forceer client-side blokkade
// omdat Formie's eigen submit-handler de native HTML5 max-attribute niet
// altijd respecteert).

document.addEventListener("DOMContentLoaded", () => {
    if (!document.body.classList.contains("dranouter-actie")) return;

    const form = document.querySelector('form[data-form-handle="dranouterActie"]');
    if (!form) return;

    const dateInput = form.querySelector('input[name="fields[geboortedatum][date]"]');
    if (!dateInput) return;

    // Max-datum dynamisch herberekenen op page-load (vandaag minus 18 jaar)
    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() - 18);
    const maxDateStr = maxDate.toISOString().slice(0, 10);
    dateInput.max = maxDateStr;

    const errorMessage =
        document.documentElement.lang?.startsWith("fr")
            ? "Tu dois avoir au moins 18 ans pour participer."
            : document.documentElement.lang?.startsWith("en")
            ? "You must be at least 18 years old to participate."
            : "Je moet minstens 18 jaar zijn om deel te nemen.";

    const validate = () => {
        if (!dateInput.value) {
            dateInput.setCustomValidity("");
            return true;
        }
        const selected = new Date(dateInput.value);
        if (selected > maxDate) {
            dateInput.setCustomValidity(errorMessage);
            return false;
        }
        dateInput.setCustomValidity("");
        return true;
    };

    dateInput.addEventListener("change", validate);
    dateInput.addEventListener("input", validate);

    // Submit-blokkade in capture-phase (loopt vóór Formie's eigen handler)
    form.addEventListener(
        "submit",
        (e) => {
            if (!validate()) {
                e.preventDefault();
                e.stopPropagation();
                dateInput.reportValidity();
            }
        },
        true,
    );
});
